import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';

@Component
(
	{
		selector: 'app-not-found',
		templateUrl: './not-found.component.html'
	}
)

export class NotFoundComponent implements AfterViewInit
{
	public settings: Settings;
	constructor(private appSettings: AppSettings, private router: Router) { this.settings = this.appSettings.settings; }

	searchResult(): void { this.router.navigate(['/search']); }

	ngAfterViewInit() { setTimeout(() => { this.settings.loadingSpinner = false; }); }
}
